import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/arrow-right.svg'
import _imports_1 from '../../../public/images/new/secondopinion_jumbotron.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-35fb4190")

_pushScopeId("data-v-35fb4190")
const _hoisted_1 = { class: "-royalBlue" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "Online Care"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Jumbotorn = _resolveComponent("Jumbotorn")

  return (_openBlock(), _createBlock(_component_Jumbotorn, null, {
    header: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.t('serious illness')) + " ", 1),
      _createVNode("span", _hoisted_1, _toDisplayString(_ctx.t('SecondOpinion2')), 1)
    ]),
    main: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.t('second-opinion-intro-1')) + " ", 1),
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.t('second-opinion-intro-2')), 1)
    ]),
    footer: _withId(() => [
      _createVNode(_component_router_link, {
        to: _ctx.linkTo,
        class: "btn-arrow-right"
      }, {
        default: _withId(() => [
          _createVNode("span", null, _toDisplayString(_ctx.t('request second opinion')), 1),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    image: _withId(() => [
      _createVNode("figure", {
        class: !!_ctx.isMobileShow ? '' : ''
      }, [
        _hoisted_4
      ], 2)
    ]),
    _: 1
  }))
})